import { render, staticRenderFns } from "./staff-manage.vue?vue&type=template&id=6dd7e08e&scoped=true&"
import script from "./staff-manage.vue?vue&type=script&lang=js&"
export * from "./staff-manage.vue?vue&type=script&lang=js&"
import style0 from "./staff-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./staff-manage.vue?vue&type=style&index=1&id=6dd7e08e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7e08e",
  null
  
)

export default component.exports